import instance from "../../axios";

const fmdUrl = (id, params = {}) => {
  const query = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join("&");
  return query
    ? `/api/dashboards/fmd/${id}?${query}`
    : `/api/dashboards/fmd/${id}`;
};

/**
 * fmd/19 returns a bare payload (no status wrapper), which the axios
 * interceptor rejects. Recover that body when it looks like window data.
 */
export const fetchUpcomingMaintenance = (params) =>
  instance({ url: fmdUrl(19, params), method: "GET" }).catch((err) => {
    if (
      err &&
      typeof err === "object" &&
      (err.next7Days !== undefined ||
        err.next30Days !== undefined ||
        err.next60Days !== undefined)
    ) {
      return err;
    }
    return Promise.reject(err);
  });

export const fetchFleetAvailability = (params) =>
  instance({ url: fmdUrl(20, params), method: "GET" });

/**
 * fmd/21 may return `{ data: { pmCompliancePercent, ... } }` without a
 * status wrapper; axios interceptor then rejects. Recover that body.
 */
const isPmCompliancePayload = (payload) =>
  payload &&
  typeof payload === "object" &&
  (payload.pmCompliancePercent !== undefined ||
    payload.totalPredictionsBeforeToday !== undefined ||
    payload.completedPredictionsBeforeToday !== undefined ||
    payload.earlyCompleted !== undefined ||
    payload.lateCompleted !== undefined ||
    payload.overdueCount !== undefined ||
    payload.totalVehicles !== undefined);

export const fetchPmCompliance = (params) =>
  instance({ url: fmdUrl(21, params), method: "GET" }).catch((err) => {
    if (isPmCompliancePayload(err)) return err;
    if (isPmCompliancePayload(err?.data)) return err.data;
    return Promise.reject(err);
  });

export const fetchWorkshopTat = (params) =>
  instance({ url: fmdUrl(22, params), method: "GET" });

export const fetchNotVisitedRecently = (params) =>
  instance({ url: fmdUrl(23, params), method: "GET" });

export const fetchCampaignOffer = (params) =>
  instance({ url: fmdUrl(24, params), method: "GET" });

export const fetchImmediateAttention = (params) =>
  instance({ url: fmdUrl(25, params), method: "GET" });

/** fmd/14 — current cost per km / day (3-month window) */
export const fetchCostPerKmCurrent = (params) =>
  instance({ url: fmdUrl(14, params), method: "GET" });

/** fmd/26 — previous / baseline cost per km / day (6-month window) */
export const fetchCostPerKmPrevious = (params) =>
  instance({ url: fmdUrl(26, params), method: "GET" });

/** fmd/27 — unexpected breakdowns: now-30-days vs 30-60-days */
export const fetchUnexpectedBreakdowns = (params) =>
  instance({ url: fmdUrl(27, params), method: "GET" });

/**
 * fmd/19details?range=next60Days&itemCode=Tyre%20Rotation
 * → { itemCode, range, plateNumbers: string[] }
 */
export const fetchUpcomingMaintenanceDetails = (params) =>
  instance({
    url: `/api/dashboards/fmd/19details`,
    method: "GET",
    params,
  });
